/* Stylesheet */

.double_slider {
  .slider {
    padding: 0;
  }

  .dark {
    --bar-background: #2f4569;
    --bar-background-active: var(--ion-gradient-primary);
  }

  .light {
    --bar-background: #dbe1ea;
    --bar-background-active: var(--ion-gradient-primary);
  }

  .disabled {
    opacity: 0.175;
  }
}
